<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box"
    :footer="null"
    :mask-closable="false"
    :destroy-on-close="true"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["1117"]') }}</h2>
      <div class="d-tip-con">
        <p>
          {{ registerTip[0] }}<br>{{ registerTip[1] }}？
        </p>
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="triggerMerge"
        >
          {{ $t('message["196"]') }}
        </a-button>
        <a-button
          class="ml-16"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { setAuth } from '@/lib/storage'
export default {
  components: {
  },
  props: {
    auth: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false,
      typeError: 0
    }
  },
  computed: {
    registerTip () {
      return this.$t('message["664"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    triggerMerge (val) {
      this.TipDialogVisible = false
      setAuth(this.auth)
      this.$store.commit('setAuth', this.auth, { root: true })
      this.$router.push({ name: 'AccountInfo' })
    }
  }
}
</script>
<style lang="scss" scoped >
.dialog-tip-blue {
  .icon-tips-info1 {
    color: #4a90e2;
  }
}
.member-limit-dialog-box {
  .ant-modal-footer {
    display: none !important;
    }
}

</style>
